import { useMutation, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { governanceApi } from 'src/Services/API';
import { UpdateMemberGovernanceDto } from 'src/types/governance.types';

export const useUpdateMemberGovernance = () => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation(
    ({ membershipId, data }: { membershipId: string; data: UpdateMemberGovernanceDto }) =>
      governanceApi.updateMemberGovernance(assetId!, membershipId, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['fetch-members', assetId]);
        queryClient.invalidateQueries(['fetch-asset-details', assetId]);
      },
    }
  );
};
